import React from "react";
import Board from "./Board";
import StatusBar from "./StatusBar";
import AboutModal from "./AboutModal";
import SettingsModal from "./SettingsModal";
import IntroModal from "./IntroModal";
import GameOverModal from "./GameOverModal";

const tileTypes = [
    "dot1", "dot2", "dot3", "dot4", "dot5", "dot6", "dot7", "dot8", "dot9",
    "bamboo1", "bamboo2", "bamboo3", "bamboo4", "bamboo5", "bamboo6", "bamboo7", "bamboo8", "bamboo9",
    "character1", "character2", "character3", "character4", "character5", "character6", "character7", "character8", "character9",
    "wind1", "wind2", "wind3", "wind4",
    "dragon1", "dragon2", "dragon3",
    "flower1", "flower2", "flower3", "flower4",
    "season1", "season2", "season3", "season4"
];

const tileset = [
    // Copy 1
    "dot1", "dot2", "dot3", "dot4", "dot5", "dot6", "dot7", "dot8", "dot9",
    "bamboo1", "bamboo2", "bamboo3", "bamboo4", "bamboo5", "bamboo6", "bamboo7", "bamboo8", "bamboo9",
    "character1", "character2", "character3", "character4", "character5", "character6", "character7", "character8", "character9",
    "wind1", "wind2", "wind3", "wind4",
    "dragon1", "dragon2", "dragon3",
    // Copy 2
    "dot1", "dot2", "dot3", "dot4", "dot5", "dot6", "dot7", "dot8", "dot9",
    "bamboo1", "bamboo2", "bamboo3", "bamboo4", "bamboo5", "bamboo6", "bamboo7", "bamboo8", "bamboo9",
    "character1", "character2", "character3", "character4", "character5", "character6", "character7", "character8", "character9",
    "wind1", "wind2", "wind3", "wind4",
    "dragon1", "dragon2", "dragon3",
    // Copy 3
    "dot1", "dot2", "dot3", "dot4", "dot5", "dot6", "dot7", "dot8", "dot9",
    "bamboo1", "bamboo2", "bamboo3", "bamboo4", "bamboo5", "bamboo6", "bamboo7", "bamboo8", "bamboo9",
    "character1", "character2", "character3", "character4", "character5", "character6", "character7", "character8", "character9",
    "wind1", "wind2", "wind3", "wind4",
    "dragon1", "dragon2", "dragon3",
    // Copy 4
    "dot1", "dot2", "dot3", "dot4", "dot5", "dot6", "dot7", "dot8", "dot9",
    "bamboo1", "bamboo2", "bamboo3", "bamboo4", "bamboo5", "bamboo6", "bamboo7", "bamboo8", "bamboo9",
    "character1", "character2", "character3", "character4", "character5", "character6", "character7", "character8", "character9",
    "wind1", "wind2", "wind3", "wind4",
    "dragon1", "dragon2", "dragon3",
    // Bonus
    "flower1", "flower2", "flower3", "flower4",
    "season1", "season2", "season3", "season4"
];

const expiredCookieDate = "Sun, 20 Jul 1969 20:17:00 UTC";

class Mahjong extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            board: {
                layer1: {
                    row1: [], row2: [], row3: [], row4: [], row5: [], row6: [], row7: [], row8: []
                },
                layer2: {
                    row1: [], row2: [], row3: [], row4: [], row5: [], row6: [], row7: [], row8: []
                },
                layer3: {
                    row1: [], row2: [], row3: [], row4: [], row5: [], row6: [], row7: [], row8: []
                },
                layer4: {
                    row1: [], row2: [], row3: [], row4: [], row5: [], row6: [], row7: [], row8: []
                },
                layer5: {
                    left: [], top: [], right1: [], right2: []
                },
            },
            matches: 0,
            matchesElements: [],
            remainingShuffles: 2,
            showAvailable: false,
            hint: null,
            hintTimer: 0,
            secondsElapsed: 0,
            victory: false,
            settings: {
                graphics: "none",
                audio: false,
                acceptCookies: false
            }
        }

        this.initialShuffle = this.initialShuffle.bind(this);
        this.distributeTiles = this.distributeTiles.bind(this);
        this.createRow = this.createRow.bind(this);

        this.handleClick = this.handleClick.bind(this);
        this.checkMatch = this.checkMatch.bind(this);
        this.setEmpty = this.setEmpty.bind(this);

        this.setSelection = this.setSelection.bind(this);
        this.clearSelection = this.clearSelection.bind(this);
        this.clearHint = this.clearHint.bind(this);

        this.toggleShowAvailable = this.toggleShowAvailable.bind(this);
        this.getAvailableTiles = this.getAvailableTiles.bind(this);
        this.checkTileAvailability = this.checkTileAvailability.bind(this);

        this.shuffleTiles = this.shuffleTiles.bind(this);
        this.getHint = this.getHint.bind(this);

        this.setSettings = this.setSettings.bind(this);

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.closeSettings = this.closeSettings.bind(this);

        this.stopPropagationFunction = this.stopPropagationFunction.bind(this);

        this.accessCookie = this.accessCookie.bind(this);
        this.createCookie = this.createCookie.bind(this);

        this.newGame = this.newGame.bind(this);
    }



    initialShuffle(tileset) {
        let newTileset = [...tileset];
        let shuffledTileset = [];

        for (let i = 0; i < tileset.length; i++) {
            let randomTile = newTileset.splice(Math.floor(Math.random() * newTileset.length), 1);
            shuffledTileset.push(randomTile[0]);
        }

        return shuffledTileset;
    }

    distributeTiles(tileset) {
        this.setState(
            {
                board: {
                    layer1: {
                        row1: this.createRow(tileset, 12, 1),
                        row2: this.createRow(tileset, 8, 3),
                        row3: this.createRow(tileset, 10, 2),
                        row4: this.createRow(tileset, 12, 1),
                        row5: this.createRow(tileset, 12, 1),
                        row6: this.createRow(tileset, 10, 2),
                        row7: this.createRow(tileset, 8, 3),
                        row8: this.createRow(tileset, 12, 1)
                    },
                    layer2: {
                        row1: this.createRow(tileset, 0, 7),
                        row2: this.createRow(tileset, 6, 4),
                        row3: this.createRow(tileset, 6, 4),
                        row4: this.createRow(tileset, 6, 4),
                        row5: this.createRow(tileset, 6, 4),
                        row6: this.createRow(tileset, 6, 4),
                        row7: this.createRow(tileset, 6, 4),
                        row8: this.createRow(tileset, 0, 7)
                    },
                    layer3: {
                        row1: this.createRow(tileset, 0, 7),
                        row2: this.createRow(tileset, 0, 7),
                        row3: this.createRow(tileset, 4, 5),
                        row4: this.createRow(tileset, 4, 5),
                        row5: this.createRow(tileset, 4, 5),
                        row6: this.createRow(tileset, 4, 5),
                        row7: this.createRow(tileset, 0, 7),
                        row8: this.createRow(tileset, 0, 7),
                    },
                    layer4: {
                        row1: this.createRow(tileset, 0, 7),
                        row2: this.createRow(tileset, 0, 7),
                        row3: this.createRow(tileset, 0, 7),
                        row4: this.createRow(tileset, 2, 6),
                        row5: this.createRow(tileset, 2, 6),
                        row6: this.createRow(tileset, 0, 7),
                        row7: this.createRow(tileset, 0, 7),
                        row8: this.createRow(tileset, 0, 7),
                    },
                    layer5: {
                        left: tileset.splice(0, 1),
                        top: tileset.splice(0, 1),
                        right1: tileset.splice(0, 1),
                        right2: tileset.splice(0, 1)
                    }
                }
            },
            
            // Initialize the number of available matches after tiles have been distributed.
            () => this.getAvailableTiles()
        );

    }


    createRow(tileset, rowLength, emptyLength) {
        let row = tileset.splice(0, rowLength);
        for (let i = 0; i < emptyLength; i++) {
            row.unshift("empty");
            row.push("empty");
        }
        return row;
    }

 
    handleClick(event) {
        event.stopPropagation();

        if (this.checkTileAvailability(event.target)) {

            if (this.state.hint === null) {
                this.checkMatch(event) ? this.setEmpty(event, this.state): this.setSelection(event);

            } else if (event.target === this.state.hint[0] || event.target === this.state.hint[1]) {

                // See if the currently selected tile is the same as the hinted tile.
                // Matches the currently selected tile if they're the same.
                if (this.state.currentSelection) {
                    if (this.state.currentSelection.tile === event.target.dataset.tile) {
                        this.checkMatch(event) ? this.setEmpty(event, this.state): this.setSelection(event);
                        this.clearHint();
                        return;
                    }
                }

                let newState = this.state;

                newState.board[newState.hint[0].dataset.layer][newState.hint[0].dataset.row][newState.hint[0].dataset.index] = "empty";
                newState.board[newState.hint[1].dataset.layer][newState.hint[1].dataset.row][newState.hint[1].dataset.index] = "empty";

                newState.hint[0].className = "empty";
                newState.hint[1].className = "empty";

                newState.hint = null;

                this.setState(newState, () => {
                    this.clearSelection();
                    this.getAvailableTiles();
                });

                

            } else {
                this.checkMatch(event) ? this.setEmpty(event, this.state): this.setSelection(event);
            }

        }

    }

    checkMatch(event) {
        if (this.state.currentSelection) {

            if (this.state.currentSelection.layer === event.target.dataset.layer 
                && this.state.currentSelection.row === event.target.dataset.row
                && this.state.currentSelection.index === event.target.dataset.index) {
                    // this.clearSelection();
                    return false;

            } else if (event.target.dataset.tile === this.state.currentSelection.tile && event.target.id !== this.state.currentSelection.id) {

                // this.setEmpty(event, this.state);
                return true;

            } else if (event.target.dataset.tile === "flower1" || 
                        event.target.dataset.tile === "flower2" || 
                        event.target.dataset.tile === "flower3" || 
                        event.target.dataset.tile === "flower4") {
                if (this.state.currentSelection.tile === "flower1" || 
                    this.state.currentSelection.tile === "flower2" || 
                    this.state.currentSelection.tile === "flower3" || 
                    this.state.currentSelection.tile === "flower4") {

                        // this.setEmpty(event, this.state);
                        return true;
        
                } else {
                    // this.setSelection(event);
                    return false;
                }

            } else if (event.target.dataset.tile === "season1" || 
                        event.target.dataset.tile === "season2" || 
                        event.target.dataset.tile === "season3" || 
                        event.target.dataset.tile === "season4") {
                if (this.state.currentSelection.tile === "season1" || 
                    this.state.currentSelection.tile === "season2" || 
                    this.state.currentSelection.tile === "season3" || 
                    this.state.currentSelection.tile === "season4") {

                        // this.setEmpty(event, this.state);
                        return true;

                } else {
                    // this.setSelection(event);
                    return false;
                }

            } else {
                // this.setSelection(event);
                return false;
            }

        } else {
            // this.setSelection(event);
            return false;
        }

        // this.getAvailableTiles();
    }

    setSelection(event) {
        if (this.state.currentSelection) {
            this.clearSelection();
            if (this.state.currentSelection.layer === event.target.dataset.layer 
                && this.state.currentSelection.row === event.target.dataset.row
                && this.state.currentSelection.index === event.target.dataset.index) {
                    return;
            }
        }

        this.setState({
            currentSelection: {
                id: event.target.id,
                layer: event.target.dataset.layer,
                row: event.target.dataset.row,
                index: event.target.dataset.index,
                tile: event.target.dataset.tile
            }
        });

        event.target.classList.add("tile-selected");
    }

    setEmpty(event, state) {

        event.target.className = "empty";
        document.getElementById(this.state.currentSelection.id).className = "empty";

        let newState = state;

        newState.board[event.target.dataset.layer][event.target.dataset.row][event.target.dataset.index] = "empty";
        newState.board[this.state.currentSelection.layer][this.state.currentSelection.row][this.state.currentSelection.index] = "empty";

        newState.currentSelection = null;

        this.setState(newState);
        
        this.getAvailableTiles();
    }

    clearSelection() {
        let tilesArr = document.querySelectorAll(".tile");
        tilesArr.forEach(tile => tile.classList.remove("tile-selected"));

        this.setState({
            currentSelection: null
        });
    }

    clearHint() {
        let tilesArr = document.querySelectorAll(".tile");
        tilesArr.forEach(tile => tile.classList.remove("tile-hint"));

        this.setState({
            currentSelection: null,
            hint: null
        });
    }

    toggleShowAvailable(event) {
        event.preventDefault();
        if (this.state.showAvailable) {
            document.getElementById("available-tiles-active").classList.add("display-none");
            document.getElementById("available-tiles-inactive").classList.remove("display-none");
            this.setState(
                {
                    showAvailable: false
                },
                
                () => this.getAvailableTiles()
            );
        } else {
            document.getElementById("available-tiles-active").classList.remove("display-none");
            document.getElementById("available-tiles-inactive").classList.add("display-none");
            this.setState(
                {
                    showAvailable: true
                },
                
                () => this.getAvailableTiles()
            );
        }
    }

    getAvailableTiles() {
        let currentTiles = document.querySelectorAll(".tile");
        let availableTiles = [];
        let availableTilesElements = [];
        let numMatches = 0;
        // console.log(currentTiles[0].dataset);
        
        currentTiles.forEach(tile => {
            if (this.checkTileAvailability(tile)) {
                availableTiles.push(tile);
                tile.classList.remove("tile-dim");
            } else {
                if (this.state.showAvailable) {
                    tile.classList.add("tile-dim");
                } else {
                    tile.classList.remove("tile-dim");
                }
            }
        });
        // console.log(availableTiles);

        for (let i = 0; i < availableTiles.length; i++) {
            for (let v = i + 1; v < availableTiles.length; v++) {
                // Logic for bonus tiles
                if (availableTiles[i].dataset.tile === "flower1" ||
                    availableTiles[i].dataset.tile === "flower2" ||
                    availableTiles[i].dataset.tile === "flower3" ||
                    availableTiles[i].dataset.tile === "flower4") {
                        if (availableTiles[v].dataset.tile === "flower1" ||
                            availableTiles[v].dataset.tile === "flower2" ||
                            availableTiles[v].dataset.tile === "flower3" ||
                            availableTiles[v].dataset.tile === "flower4") {
                                numMatches += 1;
                                availableTilesElements.push([availableTiles[i], availableTiles[v]]);
                        }
                } else if (availableTiles[i].dataset.tile === "season1" ||
                            availableTiles[i].dataset.tile === "season2" ||
                            availableTiles[i].dataset.tile === "season3" ||
                            availableTiles[i].dataset.tile === "season4") {
                                if (availableTiles[v].dataset.tile === "season1" ||
                                    availableTiles[v].dataset.tile === "season2" ||
                                    availableTiles[v].dataset.tile === "season3" ||
                                    availableTiles[v].dataset.tile === "season4") {
                                        numMatches += 1;
                                        availableTilesElements.push([availableTiles[i], availableTiles[v]]);
                                }
                // Logic for other tiles
                } else if (availableTiles[i].dataset.tile === availableTiles[v].dataset.tile) {
                    numMatches += 1;
                    availableTilesElements.push([availableTiles[i], availableTiles[v]]);
                }
            }
        }

        // console.log(numMatches);
        this.setState({
            matches: numMatches,
            matchesElements: availableTilesElements
        });

        if (numMatches === 0) {
            currentTiles.forEach(tile => tile.classList.add("tile-inactive"));

            if (document.querySelectorAll(".tile").length === 0) {
                clearInterval(this.interval);
                this.setState({
                    victory: true
                });

                document.getElementById("modal-game-over").classList.remove("display-none");
                
            } else if (this.state.remainingShuffles === 0) {
                clearInterval(this.interval);
                document.getElementById("modal-game-over").classList.remove("display-none");
            }
        }
    }

    checkTileAvailability(tile) {
        let layer = tile.dataset.layer;
        let row = tile.dataset.row;
        let index = tile.dataset.index;

        if (layer === "layer4") {
            if (this.state.board.layer5.top[0] === "empty") {
                // console.log("available");
                return true;
            } else {
                // console.log("unavailable - top tile still in place");
                return false;
            }
        } else if (layer !== "layer5") {
            let layerAbove = "layer" + (parseInt(layer.split("").splice(5, 1)) + 1);

            // Make sure the tile above is empty.
            if (this.state.board[layerAbove][row][index] === "empty") {
                // console.log("tile above is empty");
                // Make sure that the tile is clear on the left or right side.
                if (this.state.board[layer][row][parseInt(index) - 1] === "empty" || this.state.board[layer][row][parseInt(index) + 1] === "empty") {

                    if (layer === "layer1") {
                        if (row === "row4" || row === "row5") {
                            if (parseInt(index) === 1 && this.state.board.layer5.left[0] !== "empty") {
                                // console.log("available");
                                return false;
                            } else if (parseInt(index) === 12 && this.state.board.layer5.right1[0] !== "empty") {
                                // console.log("available");
                                return false;
                            } else {
                                // console.log("unavailable - side tile(s) still in place");
                                // console.log("index: " + index);
                                return true;
                            }
                        } else {
                            // console.log("available");
                            return true;
                        }
                    } else {
                        // console.log("available");
                        return true;
                    }
                } else {
                    // console.log("unavailable - tile is not clear on one or both sides");
                    return false;
                }
            } else {
                // console.log("unavailable - there is a tile above this tile");
                return false;
            }

        } else if (layer === "layer5") {
            if (row === "right1") {
                // console.log("right1");
                if (this.state.board.layer5.right2[0] === "empty") {
                    // console.log("available");
                    return true;
                } else {
                    // console.log("unavailable - rightmost tile still in play");
                    return false;
                }
            } else {
                // console.log("available");
                return true;
            }
        }
    }

    shuffleTiles(event) {
        event.preventDefault();
        if (this.state.remainingShuffles > 0) {

            if (this.state.remainingShuffles === 2) {
                document.getElementById("shuffle-pip-2").classList.add("icon-button-inactive");
            } else if (this.state.remainingShuffles === 1) {
                document.getElementById("shuffle-pip-1").classList.add("icon-button-inactive");
                document.getElementById("button-shuffle").classList.add("icon-button-inactive");
                document.getElementById("button-shuffle").setAttribute("title", "No shuffles remaining");
            }

            let newState = this.state;

            let currentTiles = document.querySelectorAll(".tile");
            let tilesArray = [];

            currentTiles.forEach(tile => {
                tilesArray.push(tile.dataset.tile);
                tile.classList.remove(...tileTypes, "tile-selected", "tile-inactive");
                tile.dataset.tile = "";
            });

            currentTiles.forEach(tile => {
                let randomTile = tilesArray.splice(Math.floor(Math.random() * tilesArray.length), 1);
                tile.classList.add(randomTile[0]);
                tile.dataset.tile = randomTile[0];

                newState.board[tile.dataset.layer][tile.dataset.row][tile.dataset.index] = tile.dataset.tile;
            });

            newState.currentSelection = null;

            newState.remainingShuffles--;

            this.setState(newState, () => this.getAvailableTiles());
            this.clearHint();
        }
    }

    getHint(event) {
        event.preventDefault();
        if (this.state.hint === null) {
            if (this.state.hintTimer > 30) {
                this.clearSelection();
                let hint = this.state.matchesElements[Math.floor(Math.random() * this.state.matchesElements.length)];
                hint.forEach(tile => {
                    tile.classList.add("tile-hint");
                });

                this.setState({
                    hint: hint,
                    hintTimer: 0
                });

                document.getElementById("button-hint").classList.add("icon-button-inactive");
                document.getElementById("button-hint-cooldown").classList.remove("display-none");
            }
        }
    }

    tick() {
        this.setState(state => ({
            secondsElapsed: state.secondsElapsed + 1,
            hintTimer: state.hintTimer + 1
        }));

        if (this.state.hintTimer === 30) {
            document.getElementById("button-hint").classList.remove("icon-button-inactive");
            document.getElementById("button-hint-cooldown").classList.add("display-none");
            document.getElementById("button-hint-cooldown").style.height = 0;
        } else if (this.state.hintTimer < 30) {
            let height = this.state.hintTimer * 100 / 30;
            document.getElementById("button-hint-cooldown").style.height = height + "%";
        }
    }

    openModal(event) {
        event.preventDefault();
        document.getElementById(event.currentTarget.dataset.modalid).classList.remove("display-none");
    }

    closeModal(event) {
        event.preventDefault();
        document.getElementById(event.currentTarget.dataset.modalid).classList.add("display-none");
    }

    closeSettings(event) {
        let graphics = document.getElementById(event.target.dataset.modalid).querySelectorAll(".graphics-radio");

        for (let i = 0; i < graphics.length; i++) {
            if (graphics[i].value === this.state.settings.graphics) {
                graphics[i].checked = true;
            }
        }

        if (this.state.settings.acceptCookies) {
            document.getElementById("accept-cookies").checked = true;
        } else {
            document.getElementById("accept-cookies").checked = false;
        }

        document.getElementById(event.target.dataset.modalid).classList.add("display-none");
    }

    setSettings(event) {
        event.preventDefault();
        let newState = this.state;
        let modalGraphics = document.getElementById(event.target.dataset.modalid).querySelectorAll(".graphics-radio");
        let allGraphics = document.querySelectorAll(".graphics-radio");
        let cookieCheckbox = document.getElementById(event.target.dataset.modalid).querySelector("input[type='checkbox']");

        for (let i = 0; i < modalGraphics.length; i++) {
            if (modalGraphics[i].checked) {
                newState.settings.graphics = modalGraphics[i].value;
            }
        }

        newState.settings.acceptCookies = cookieCheckbox.checked;
        this.setState(newState);
        this.closeModal(event);

        for (let i = 0; i < allGraphics.length; i++) {
            if (allGraphics[i].value === newState.settings.graphics) {
                allGraphics[i].checked = true;
            }
        }

        document.getElementById("accept-cookies").checked = cookieCheckbox.checked;

        if (cookieCheckbox.checked) {
            this.createCookie("graphics", newState.settings.graphics, 365);
        } else {
            if (this.accessCookie("graphics")) {
                document.cookie = "graphics= ; expires=" + expiredCookieDate + ";";
            }
        }

        if (event.target.dataset.modalid === "modal-intro") {
            this.interval = setInterval(() => this.tick(), 1000);
        }
    }

    stopPropagationFunction(event) {
        event.stopPropagation();
    }


    // Cookies
    accessCookie(cookieName) {
        let cookieNameEq = cookieName + "=";
        let cookiesArray = document.cookie.split(";");
        for (let i = 0; i < cookiesArray.length; i++) {
            let tempCookie = cookiesArray[i].trim();
            if (tempCookie.indexOf(cookieNameEq) === 0) {
                return tempCookie.substring(cookieNameEq.length, tempCookie.length);
            }
        }
        return false;
    }

    createCookie(cookieName, cookieValue, daysToExpire) {
        let date = new Date();
        date.setTime(date.getTime() + (daysToExpire*24*60*60*1000));
        document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
    }




    newGame(event) {
        event.preventDefault();

        let inactiveTiles = document.querySelectorAll(".tile-inactive");
        inactiveTiles.forEach(tile => tile.classList.remove("tile-inactive"));

        let shuffledTileset = this.initialShuffle(tileset);
        this.distributeTiles(shuffledTileset);

        this.setState({
            secondsElapsed: 0,
            hintTimer: 0,
            hint: null,
            remainingShuffles: 2,
            victory: false
        });

        
        document.getElementById("button-hint-cooldown").classList.remove("display-none");
        document.getElementById("button-hint-cooldown").style.height = 0;
        document.getElementById("button-hint").classList.add("icon-button-inactive");

        document.getElementById("shuffle-pip-2").classList.remove("icon-button-inactive");
        document.getElementById("shuffle-pip-1").classList.remove("icon-button-inactive");
        document.getElementById("button-shuffle").classList.remove("icon-button-inactive");

        document.getElementById("modal-game-over").classList.add("display-none");

        this.interval = setInterval(() => this.tick(), 1000);
    }

    


    componentDidMount() {
        let shuffledTileset = this.initialShuffle(tileset);
        this.distributeTiles(shuffledTileset);

        if (this.accessCookie("graphics")) {
            let graphicsSetting = this.accessCookie("graphics");

            this.setState({
                settings: {
                    graphics: graphicsSetting,
                    acceptCookies: true
                }
            });

            document.getElementById("accept-cookies").checked = true;

            let graphics = document.querySelectorAll(".graphics-radio");
    
            for (let i = 0; i < graphics.length; i++) {
                if (graphics[i].value === graphicsSetting) {
                    graphics[i].checked = true;
                }
            }

            this.interval = setInterval(() => this.tick(), 1000);
        }
    }
   
    render() {
        let bgClasses;

        if (this.state.settings.graphics === "none") {
            bgClasses = "background bg-none";
        } else if (this.state.settings.graphics === "low") {
            bgClasses = "background bg-low";
        } else if (this.state.settings.graphics === "medium" || this.state.settings.graphics === "high") {
            bgClasses = "background bg-medium";
        } else if (this.state.settings.graphics === "veryhigh" || this.state.settings.graphics === "ultra") {
            bgClasses = "background bg-high";
        }

        return (
            <div>
                <div className={bgClasses} />
                <div className="board-viewport" onClick={this.clearSelection} >
                    <div className="board-wrapper">
                        <Board board={this.state.board} clicker={this.handleClick} graphics={this.state.settings.graphics} accessCookie={this.accessCookie} />
                    </div>
                </div>
                <StatusBar matches={this.state.matches} showAvailable={this.toggleShowAvailable} shuffler={this.shuffleTiles} hint={this.getHint} time={this.state.secondsElapsed} openModal={this.openModal} />
                <AboutModal closeButton={this.closeModal} stopPropagation={this.stopPropagationFunction} />
                <SettingsModal closeButton={this.closeSettings} stopPropagation={this.stopPropagationFunction} setSettings={this.setSettings} />
                <GameOverModal victory={this.state.victory} newGame={this.newGame} />
                <IntroModal closeButton={this.closeSettings} stopPropagation={this.stopPropagationFunction} setSettings={this.setSettings} accessCookie={this.accessCookie} />
            </div>
        );
    }
}

export default Mahjong;